import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./authProtected";
import { usePermission } from "../hooks/usePermission";
import NotAuthorized from "../pages/NotAuth";
import AccessRoutes from "./acessRoutes";

// Simple wrapper for route protection
const AuthWrapper = ({ children }) => {
  const token = sessionStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
};

const AppRoutes = () => {
  const { hasPageAccess } = usePermission();
  return (
    <Suspense>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}

        {/* Protected Routes */}
        {authProtectedRoutes.map(({ pagename, path, element }) =>
          hasPageAccess(pagename) ? (
            <Route
              key={path}
              path={path}
              element={
                <AuthWrapper>
                  <AccessRoutes
                    pageName={pagename}
                    hasPageAccess={hasPageAccess}
                  >
                    {element}
                  </AccessRoutes>
                </AuthWrapper>
              }
            />
          ) : (
            <Route
              key="not-authorized"
              path="/not-authorized"
              exact={true}
              element={
                <AuthWrapper>
                  <NotAuthorized />
                </AuthWrapper>
              }
            />
          ),
        )}

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
